import Terms from '@/lib/forms/components/Terms';

function DistributorTerms() {
  return (
    <Terms title="Distributor Terms & Conditions">
      <p>By accepting these Terms & Conditions, you agree to:</p>
      <ul>
        <li>Follow all applicable laws and regulations</li>
        <li>Maintain accurate and up-to-date information</li>
        <li>Respect the intellectual property rights of others</li>
        <li>Use the platform responsibly and ethically</li>
      </ul>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore dignissimos temporibus sapiente perferendis
        modi quaerat, praesentium explicabo doloremque cum quos fuga, dicta, eligendi accusamus? Esse ipsum
        necessitatibus quos unde, repellat quasi? Eius, optio sunt fugit amet suscipit quibusdam distinctio ipsam
        eveniet repellat, ullam odit quisquam modi velit voluptas officiis unde libero quod molestiae commodi. Dolorem
        placeat rerum odit, cum esse enim. Explicabo, illum libero totam nobis dolorem suscipit. Repellat, libero non
        voluptate tenetur unde sed cupiditate adipisci nesciunt optio voluptas consequuntur a ipsum enim id quasi,
        possimus nostrum natus! Vero id at obcaecati accusamus adipisci voluptatibus nostrum cupiditate sed amet!
      </p>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore dignissimos temporibus sapiente perferendis
        modi quaerat, praesentium explicabo doloremque cum quos fuga, dicta, eligendi accusamus? Esse ipsum
        necessitatibus quos unde, repellat quasi? Eius, optio sunt fugit amet suscipit quibusdam distinctio ipsam
        eveniet repellat, ullam odit quisquam modi velit voluptas officiis unde libero quod molestiae commodi. Dolorem
        placeat rerum odit, cum esse enim. Explicabo, illum libero totam nobis dolorem suscipit. Repellat, libero non
        voluptate tenetur unde sed cupiditate adipisci nesciunt optio voluptas consequuntur a ipsum enim id quasi,
        possimus nostrum natus! Vero id at obcaecati accusamus adipisci voluptatibus nostrum cupiditate sed amet!
      </p>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore dignissimos temporibus sapiente perferendis
        modi quaerat, praesentium explicabo doloremque cum quos fuga, dicta, eligendi accusamus? Esse ipsum
        necessitatibus quos unde, repellat quasi? Eius, optio sunt fugit amet suscipit quibusdam distinctio ipsam
        eveniet repellat, ullam odit quisquam modi velit voluptas officiis unde libero quod molestiae commodi. Dolorem
        placeat rerum odit, cum esse enim. Explicabo, illum libero totam nobis dolorem suscipit. Repellat, libero non
        voluptate tenetur unde sed cupiditate adipisci nesciunt optio voluptas consequuntur a ipsum enim id quasi,
        possimus nostrum natus! Vero id at obcaecati accusamus adipisci voluptatibus nostrum cupiditate sed amet!
      </p>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore dignissimos temporibus sapiente perferendis
        modi quaerat, praesentium explicabo doloremque cum quos fuga, dicta, eligendi accusamus? Esse ipsum
        necessitatibus quos unde, repellat quasi? Eius, optio sunt fugit amet suscipit quibusdam distinctio ipsam
        eveniet repellat, ullam odit quisquam modi velit voluptas officiis unde libero quod molestiae commodi. Dolorem
        placeat rerum odit, cum esse enim. Explicabo, illum libero totam nobis dolorem suscipit. Repellat, libero non
        voluptate tenetur unde sed cupiditate adipisci nesciunt optio voluptas consequuntur a ipsum enim id quasi,
        possimus nostrum natus! Vero id at obcaecati accusamus adipisci voluptatibus nostrum cupiditate sed amet!
      </p>
    </Terms>
  );
}

export default DistributorTerms;
